export default __webpack_public_path__ + "static/media/207.e09aa005.png";